module.exports = __webpack_public_path__ + "img/big_eye.05098aa1.png";